import { cn } from "@/lib/utils";

type BoxProps = React.HTMLAttributes<HTMLDivElement>;

export const Box = ({ className, ...props }: BoxProps) => (
	<div className={cn("rounded-xl border border-border bg-card text-card-foreground", className)} {...props} />
);

type BoxHeaderProps = {
	icon?: React.ReactNode;
	title: string;
	action?: React.ReactNode;
};

export const BoxHeader = ({ icon, title, action }: BoxHeaderProps) => (
	<div className="p-4 pb-3 flex items-center justify-between">
		<h3 className="text-sm font-medium text-muted-foreground flex items-center gap-2">
			{icon}
			{title}
		</h3>
		{action}
	</div>
);

type BoxContentProps = React.HTMLAttributes<HTMLDivElement>;

export const BoxContent = ({ className, ...props }: BoxContentProps) => (
	<div className={cn("px-4 pb-4", className)} {...props} />
);

export const Divider = () => <div className="h-px bg-border" />;
